// import components
import {
  styled,
  IconButton,
  IconButtonProps,
  alpha,
  Box,
  BoxProps
} from '@mui/material';

export const StyledNotesSliderIconButton = styled(IconButton)<IconButtonProps>(
  ({ theme }) => ({
    backgroundColor: alpha(theme.palette.primary.main, 0.12),
    position: 'absolute',
    width: '32px',
    height: '32px',
    top: '50%',
    // transform: 'translateY(-50%)',
    zIndex: 1,

    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.3)
    }
  })
);

export const StyledNoteSliderMotionBox = styled(Box)<BoxProps>(({}) => ({
  display: 'grid',
  overflow: 'hidden'
}));

export const StyledIndicatorBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isCompact'
})<BoxProps & { isCompact?: boolean }>(({ theme, isCompact }) => ({
  position: 'absolute',
  bottom: isCompact ? 10 : 20,
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  maxWidth: isCompact
    ? `calc(100% - ${theme.spacing(10)})`
    : `calc(100% - ${theme.spacing(12)})`,
  overflow: 'hidden',
  boxSizing: 'border-box',
  paddingInline: theme.spacing(0.5),
  gap: theme.spacing(1),
  zIndex: 1
}));

export const StyledIndicatorEllipsis = styled('button', {
  shouldForwardProp: (prop) => prop !== 'isCompact'
})<{ isCompact?: boolean }>(({ theme, isCompact }) => ({
  minWidth: isCompact ? '20px' : '24px',
  height: '14px',
  border: 0,
  background: 'transparent',
  padding: 0,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: isCompact ? '10px' : '11px',
  fontWeight: 500,
  lineHeight: 1,
  color: alpha(theme.palette.primary.main, 0.6),
  userSelect: 'none',
  fontVariantNumeric: 'tabular-nums',
  cursor: 'pointer',
  borderRadius: theme.shape.borderRadius,

  '&:hover': {
    color: alpha(theme.palette.primary.main, 0.85),
    backgroundColor: alpha(theme.palette.primary.main, 0.08)
  },

  '&:focus-visible': {
    outline: `1px solid ${alpha(theme.palette.primary.main, 0.45)}`,
    outlineOffset: 1
  }
}));

export const sliderMotionAnimation = {
  enter: (direction: number) => ({
    x: direction > 0 ? 300 : -300,
    opacity: 0
  }),
  center: { x: 0, opacity: 1 },
  exit: (direction: number) => ({
    x: direction > 0 ? -300 : 300,
    opacity: 0
  })
};
